module.exports = __webpack_public_path__ + "img/relay.137fd46f.svg";